<script>
import * as restfulService from '../../../services/restfulService'
import helpers from '@mixins/helper'
import {mapGetters} from 'vuex'

export default {
  mixins: [helpers],
  name: 'dashboard-verifica-contrato-pendente-de-assinatura-popup',
  data () {
    return {
      mostrarModal: false
    }
  },
  mounted () {
    this.buscarPopup()
  },
  computed: {
    ...mapGetters(['currentUser', 'isLogged']),
    isMobileSize: function () {
      return this.isMobile().any()
    },
    primeiroNome: function () {
      if (this.isLogged) {
        let nome = (this.currentUser.pessoa.nome.split(' ')[0] || '').toLowerCase()
        return nome.charAt(0).toUpperCase() + nome.slice(1)
      }
      return ''
    }
  },
  methods: {
    buscarPopup () {
      restfulService.get('pessoa', 'contrato-pendente')
        .then(response => {
          this.mostrarModal = !!response.pendente
        })
        .catch(e => {
          console.log(e)
        })
    }
  }
}
</script>

<template>
  <div>
    <v-dialog v-model="mostrarModal"
              :width="isMobileSize ? '90%' : '40%'"
              persistent>
      <v-card class="popup-modal">
        <v-container>
          <h3 class="pb-3" :class="{'display-0': isMobileSize, 'display-1': !isMobileSize}">
            Assinatura de contrato pendente
          </h3>
          <div class="text">
            <p :class="{'body-1': isMobileSize, 'subheading': !isMobileSize}">
              Olá <strong>{{ primeiroNome }}</strong>, identificamos que você possui um contrato pendente de assinatura.
              Para concluir essa etapa, verifique o e-mail enviado a você em <strong>{{ currentUser.pessoa.email_contrato }}</strong> e assine o documento o quanto antes.
              <br><br>
              * Se você já realizou a assinatura e esta mensagem continuar aparecendo, entre em contato com a Central de
              Atendimento para mais informações.
            </p>
          </div>
        </v-container>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="mostrarModal = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>



// WEBPACK FOOTER //
// VerificaContratoPendenteDeAssinaturaPopup.vue?44918eeb